import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Nav, NavDropdown, NavItem, Row, Col, Badge, Label, Glyphicon, MenuItem } from 'react-bootstrap';
import { EditClientForm } from './ClientForm';
import { EditIntakeForm } from './IntakeForm';
import TaskEditor, { validateTaskFields } from './common/TaskEditor';
import TextArea from './common/TextArea';
import ConfirmDialog from './common/ConfirmDialog';
import HelpDialog from './common/HelpDialog';
import TemplatesForm, { TEMPLATES_CARDS } from './TemplatesForm';
import TemplatesHelpDialog from './common/TemplatesHelpDialog';
import EditTypesDialog from './common/EditTypesDialog';
import Fingerprint2 from 'fingerprintjs2';
import { isEmptyObject,
         isEmptyString } from '../validators/formValidators';

import { caseSetServerError } from '../actions/caseActions';

import { clientSavingNeededAction } from '../actions/clientActions';

import { userLogOutAction,
         userThemeAction,
         userCaseStatesUpdateAction,
         userFeedbackAction } from '../actions/userActions';

import { getFullName, filteredRoute } from '../helpers/utils';

import MomentTz from 'moment-timezone';
import { clearClientToken, isImpersonating } from '../../client/token';
import WelcomeDialog from './common/WelcomeDialog';
import Tour from './common/Tour';
import Select from './common/Select';


class MainMenu extends PureComponent {
    constructor(props) {
        super(props);
        this.switchToTab = this.switchToTab.bind(this);
        this.feedbackDialogConfirm = this.feedbackDialogConfirm.bind(this);
        this.logOut = this.logOut.bind(this);
        this.state = {
            dialogTitle: '',
            dialogText: '',
            dialogCancel: () => {this.setState({dialogOpen: false})},
            dialogConfirm: () => {},
            dialogOpen: false,
            dialogSize: undefined,
            contactFormEditorDialogOpen: false,
            intakeFormEditorDialogOpen: false,
            feedbackDialogOpen: false,
            helpDialogOpen: false,
            feedbackMessage: undefined,
            templatesHelpDialogOpen: false,
            templatesConfigureDialogOpen: false,
            emailConfigureDialogOpen: false,
            editCaseStatesOpen: false,
            intakeConfigureDialogOpen: false,
            editPublicIntakeFormsOpen: false,
            embeddedPublicIntakeFormCaseType: undefined,
            intakeEditor: false,
            contactEditor: false,
            tasklistEditor: false,
            editingTasks: [],
            toursAvailable: [],
            tourRun: false,
            impersonating: false,
        };
    }

    componentDidMount() {
        // Admin impersonation (stashed admin token) — suppress welcome
        // dialogs and tours; the admin is just looking around.
        if (isImpersonating()) {
            this.setState({ impersonating: true });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.state.impersonating && nextProps.impersonating) {
            this.setState({ impersonating: true });
        }

        if (nextProps.caseTypes && nextProps.caseTypes.length > 0 && !this.state.embeddedPublicIntakeFormCaseType) {
            this.setState({ embeddedPublicIntakeFormCaseType: nextProps.caseTypes[0] });
        }
    }

    logOut(evt) {
        if (evt) {
            evt.preventDefault();
        }

        clearClientToken();
        this.props.dispatch(userLogOutAction());
        browserHistory.push('/user/login');
    }


    feedbackDialogConfirm() {
        this.setState({loading: true});
        new Fingerprint2({excludeWebGL: true, excludeCanvas: true}).get((fingerprint, components) => {
            this.props.dispatch(userFeedbackAction(this.state.feedbackMessage,
                                                  {
                                                    location: this.props.routingInfo,
                                                    timezone: MomentTz.tz.guess(),
                                                    windowWidth: window.innerWidth,
                                                    windowHeight: window.innerHeight,
                                                    fingerprint,
                                                    components
                                                  }))
                .then(result => {
                    if (!result) {
                        console.error('Feedback not sent.');
                        this.props.dispatch(caseSetServerError('Feedback sending failure.'));
                        this.setState({loading: false});
                        return;
                    }

                    this.setState({feedbackMessage: '', feedbackDialogOpen: false, loading: false});
                })
                .catch(error => {
                    console.error(new Error().stack, error);
                    this.props.dispatch(caseSetServerError(error));
                    this.setState({loading: false});
                });
        });

    }

    switchToTab(route) {
        if (!route) {
            return;
        }

        this.props.dispatch(clientSavingNeededAction(false));
        this.setState({
            dialogOpen: false
        });

        browserHistory.push(route);
    }

    render() {
        let currentCase = {...this.props.cases.current, ...this.props.cases.caseCurrentSaved};
        let casesLabel;
        let casesRoute;
        let casesAllLabel = "Cases";
        let casesAllRoute = filteredRoute('/case/all', this.props.cases.filter);
        if (this.props.cases.rows) {
            casesAllLabel = (<span>Cases <Badge style={{backgroundColor: "#666"}}>{this.props.cases.total}</Badge></span>);
        }

        let caseTabState = this.props.cases.tabState;
        let caseDetailTabOpened = false;
        switch (caseTabState) {
        case 'new':
            casesLabel = (<span>Case <Label style={{backgroundColor: '#24D7D2'}}>NEW</Label></span>);
            casesRoute = "/case/new";
            caseDetailTabOpened = true;
            break;

        case 'edit':
            if (!isEmptyObject(currentCase) && currentCase.client) {
                let fullName = getFullName(currentCase.client);
                if (isEmptyString(fullName)) {
                    fullName = 'EDIT';
                }

                casesLabel = (<span>Case <Label style={{backgroundColor: '#24D7D2'}}>{fullName}</Label></span>);
                casesRoute = `/case/edit/intake/${currentCase.id}`;
                caseDetailTabOpened = true;
                break;
            }

            // Otherwise fallthrough

        default:
            casesLabel = casesAllLabel;
            casesRoute = casesAllRoute;
            break;
        }

        let clientsLabel;
        let clientsRoute;
        const clientTabState = this.props.clients.tabState;
        let clientsAllLabel = "Contacts";
        const clientsAllRoute = filteredRoute('/client/all', this.props.clients.filter);
        if (this.props.clients.rows) {
            clientsAllLabel = (<span>Contacts <Badge style={{backgroundColor: "#666"}}>{this.props.clients.rows.length}</Badge></span>);
        }

        let clientDetailTabOpened = false;
        switch (clientTabState) {
        case 'new':
            clientsLabel = (<span>Contact <Label style={{backgroundColor: '#24D7D2'}}>NEW</Label></span>);
            clientsRoute = "/client/new";
            clientDetailTabOpened = true;
            break;

        case 'edit':
            if (isEmptyObject(this.props.clients.current)) {
                clientsLabel = "Contact (Loading ...)";
                clientsRoute = `/client/edit/${this.props.params.id}`;

            } else {
                let fullName = getFullName(this.props.clients.current);
                if (isEmptyString(fullName)) {
                    fullName = 'EDIT';
                }

                clientsLabel = (<span>Contact <Label style={{backgroundColor: '#24D7D2'}}>{fullName}</Label></span>);
                clientsRoute = `/client/edit/${this.props.clients.current.id}`;
            }

            clientDetailTabOpened = true;
            break;

        default:
            clientsLabel = clientsAllLabel;
            clientsRoute = clientsAllRoute;
            break;
        }

        let selectedRoute = '';
        const accountRoute = '/user/account';
        const reportsRoute = '/case/reports';
        switch (this.props.selectedTab) {
        case 'cases':
            selectedRoute = casesAllRoute;
            break;

        case 'case':
            selectedRoute = casesRoute;
            break;

        case 'clients':
            selectedRoute = clientsAllRoute;
            break;

        case 'client':
            selectedRoute = clientsRoute;
            break;

        case 'account':
            selectedRoute = accountRoute;
            break;

        case 'reports':
            selectedRoute = reportsRoute;
            break;

        default:
            assert(false);
            break;
        }

        const editCaseForms = () => {
            this.setState({
                intakeFormEditorDialogOpen: true,
            });
        };

        const editContactForms = () => {
            this.setState({
                contactFormEditorDialogOpen: true,
            });
        };

        const editCaseTypeTasks = () => {
            this.setState({
                dialogOpen: true,
                tasklistEditor: true,
                dialogTitle: 'Edit Tasks for Case Types',
                dialogText: undefined,
                dialogConfirm: () => this.setState({isTasklistFormSave: true}),
                dialogCancel: () => this.setState({dialogOpen: false, tasklistEditor: false}),
                dialogSize: undefined,
            });
        };

        const editCaseStates = () => { this.setState({ editCaseStatesOpen: true }); };
        const editEmailTemplates = () => { this.setState({ emailConfigureDialogOpen: true }); };
        const editDocumentTemplates = () => { this.setState({ templatesConfigureDialogOpen: true }); };
        const openTemplatePlaceholders = () => { this.setState({ templatesHelpDialogOpen: true }); };
        const editPublicIntakeForms = () => { this.setState({ editPublicIntakeFormsOpen: true }); }
        let selectedTabTour = this.props.selectedTab;
        if (this.props.cases.tabState !== 'edit' && selectedTabTour === 'case') {
            selectedTabTour = undefined;
        }

        const darkTheme = !!(this.props.loggedIn && this.props.loggedIn['Theme'] === 'dark');
        let menu = (
            <div>
            {!this.state.impersonating && this.props.loggedIn && !this.props.loggedIn.welcomeTourDone && 
                <WelcomeDialog editCaseForms={editCaseForms}
                               editContactForms={editContactForms}
                               editCaseTypeTasks={editCaseTypeTasks}
                               editCaseStates={editCaseStates}
                               editEmailTemplates={editEmailTemplates}
                               editDocumentTemplates={editDocumentTemplates}
                               openTemplatePlaceholders={openTemplatePlaceholders}
                />
            }
            {this.props.loggedIn && this.props.loggedIn.welcomeTourDone && 
                <Tour selectedTab={selectedTabTour}
                      impersonating={!!this.state.impersonating}
                      loggedIn={this.props.loggedIn}
                      run={this.state.tourRun}
                      onDone={() => { this.setState({ tourRun: false }); } }
                      onAvailable={tours => { this.setState({ toursAvailable: tours }); }}
                />
            }
            <Nav activeKey={selectedRoute} onSelect={this.switchToTab}>
                <NavItem data-hj-whitelist id="tour-menu-dashboard" eventKey={casesAllRoute}>Dashboard</NavItem>
                <NavItem data-hj-whitelist id="tour-menu-reports" eventKey={reportsRoute}>Reports</NavItem>
                <NavItem data-hj-whitelist id="tour-menu-contacts" eventKey={clientsAllRoute}>{clientsAllLabel}</NavItem>
                {caseDetailTabOpened && (<NavItem data-hj-whitelist id="tour-case-tab" eventKey={casesRoute}>{casesLabel}</NavItem>)}
                {clientDetailTabOpened && (<NavItem data-hj-whitelist eventKey={clientsRoute}>{clientsLabel}</NavItem>)}
            </Nav>
            <Nav pullRight activeKey={selectedRoute} onSelect={this.switchToTab}>
                <li>
                    <a role="button" tabIndex={0} id="theme-switcher"
                       title={darkTheme ? 'Switch to light mode' : 'Switch to dark mode'}
                       onClick={() => this.props.dispatch(userThemeAction(darkTheme ? 'light' : 'dark'))}
                       onKeyDown={(evt) => { if (evt.key === 'Enter' || evt.key === ' ') { evt.preventDefault(); this.props.dispatch(userThemeAction(darkTheme ? 'light' : 'dark')); } }}>
                        <Glyphicon glyph="adjust" /> {darkTheme ? 'Light' : 'Dark'}
                    </a>
                </li>
                <NavDropdown data-hj-whitelist id="tour-menu-configure" title={(<span><Glyphicon glyph="cog" /> Configure</span>)}>
                    <MenuItem data-hj-whitelist onClick={editCaseForms}><Glyphicon glyph="list-alt" /> Case Type Forms</MenuItem>
                    <MenuItem data-hj-whitelist onClick={editContactForms}><Glyphicon glyph="list-alt" /> Contact Forms</MenuItem>
                    <MenuItem data-hj-whitelist onClick={editCaseStates}><Glyphicon glyph="th-large" /> Case States</MenuItem>
                    <MenuItem data-hj-whitelist onClick={editCaseTypeTasks}><Glyphicon glyph="calendar" /> Tasks</MenuItem>
                    <MenuItem data-hj-whitelist onClick={editDocumentTemplates}><Glyphicon glyph="file" /> Templates</MenuItem>
                    <MenuItem data-hj-whitelist onClick={editPublicIntakeForms}><Glyphicon glyph="barcode" /> Embed Intake Forms</MenuItem>
                </NavDropdown>
                <NavDropdown data-hj-whitelist id="tour-menu-help" title={(<span><Glyphicon glyph="question-sign" /> Help</span>)}>
                    <MenuItem data-hj-whitelist onClick={() => { this.setState({ tourRun: true }); }} disabled={!this.state.toursAvailable.find(tour => tour === this.props.selectedTab)}><Glyphicon glyph="education" /> Launch Help Tour</MenuItem>
                    <MenuItem data-hj-whitelist onClick={openTemplatePlaceholders}><Glyphicon glyph="flash" /> Template Placeholders</MenuItem>
                    {/*<MenuItem data-hj-whitelist onClick={() => {this.setState({helpDialogOpen: true})}}><Glyphicon glyph="question-sign" /> Manual / Training Videos</MenuItem>*/}
                    <MenuItem data-hj-whitelist onClick={() => {this.setState({feedbackDialogOpen: true})}}><img src="/img/feedback.png" style={{height: '20px', marginLeft: '-5px'}} /> Send Feedback</MenuItem>
                </NavDropdown>
                <NavDropdown data-hj-whitelist id="tour-menu-account" title={(<span><Glyphicon glyph="user" /> {this.props.loggedIn && this.props.loggedIn['FirstName']}</span>)}>
                  <MenuItem data-hj-whitelist eventKey={accountRoute}><Glyphicon glyph="cog" /> Settings</MenuItem>
                  <MenuItem data-hj-whitelist divider />
                  <MenuItem data-hj-whitelist onClick={this.logOut}><Glyphicon glyph="log-out" /> Log Out</MenuItem>
                </NavDropdown>
            </Nav>
            <HelpDialog open={this.state.helpDialogOpen}
                        close={() => {
                            this.setState({helpDialogOpen: false});
                        }}
            />
            <EditClientForm renderFormEditor
                            formEditorOpen={this.state.contactFormEditorDialogOpen}
                            onFormEditorCancel={() => this.setState({contactFormEditorDialogOpen: false})}
                            onFormEditorSave={() => this.setState({contactFormEditorDialogOpen: false})}
            />
            <EditIntakeForm renderFormEditor
                            formEditorOpen={this.state.intakeFormEditorDialogOpen}
                            onFormEditorCancel={() => this.setState({intakeFormEditorDialogOpen: false})}
                            onFormEditorSave={() => this.setState({intakeFormEditorDialogOpen: false})}
            />
            <ConfirmDialog
                title={this.state.dialogTitle}
                text={this.state.dialogText}
                cancel={this.state.dialogCancel}
                confirm={this.state.dialogConfirm}
                open={this.state.dialogOpen}
                size={this.state.dialogSize}>
                <div style={{overflowY: 'visible', overflowX: 'hidden'}}>
                {this.state.tasklistEditor && (
                    <TaskEditor onSave={() => {
                                    if (!validateTaskFields(this.state.editingTasks)) {
                                        return;
                                    }

                                    this.setState({dialogOpen: false, isTasklistFormSave: false, tasklistEditor: false, editingTasks: []})
                                }}
                                onChange={tasks => {
                                    this.setState({editingTasks: tasks});
                                }}
                                isSave={this.state.isTasklistFormSave}/>
                )}
                </div>
            </ConfirmDialog>
            <ConfirmDialog  title='Send Feedback'
                            cancel={() => {this.setState({feedbackDialogOpen: false, feedbackMessage: undefined})}}
                            confirm={this.feedbackDialogConfirm}
                            confirmLabel='Send'
                            disabled={this.state.loading}
                            open={this.state.feedbackDialogOpen}>
                <Row>
                <Col xs={12}>
                <TextArea field={{
                              name: 'feedbackText',
                              value: this.state.feedbackMessage,
                              onChange: (evt) => {
                                  this.setState({feedbackMessage: evt.target.value});
                              }
                          }}
                          forceFullSize
                          disabled={this.state.loading}
                          label='Message'
                          rows={10}/>
                </Col>
                </Row>
            </ConfirmDialog>
            <TemplatesHelpDialog
                {...this.props}
                cancel={() => this.setState({templatesHelpDialogOpen: false})}
                open={this.state.templatesHelpDialogOpen}/>
            <ConfirmDialog
                title='Manage Templates'
                size='large'
                cancel={() => this.setState({templatesConfigureDialogOpen: false})}
                open={this.state.templatesConfigureDialogOpen}
            >
            <Row>
            <Col xs={12}>
            <TemplatesForm 
                enabledDocuments={TEMPLATES_CARDS.filter(v => v.value !== 'documents')}
                defaultDocument={TEMPLATES_CARDS.find(v => v.value === 'doc_templates')}
                showDelete
            />
            </Col>
            </Row>
            </ConfirmDialog>

            <EditTypesDialog types={this.props.states}
                             defaultType={{
                                type: 'New State'
                             }}
                             open={this.state.editCaseStatesOpen}
                             onClose={() => {
                                 this.setState({editCaseStatesOpen: false});
                             }}
                             label='Edit Case States'
                             typeLabel='Selected Case State'
                             loading={this.props.states == undefined}
                             modificationDisabled={(types, selectedIndex) => {                                
                                 return selectedIndex >= 0 && types[selectedIndex].type == 'Lead';
                             }}
                             dispatchSaveAction={(states) => {
                                 return userCaseStatesUpdateAction(states, 'caseStates');
                             }} />
            <ConfirmDialog open={this.state.editPublicIntakeFormsOpen}
                           cancel={() => this.setState({ editPublicIntakeFormsOpen: false })}
                           title="Embed Intake Forms in a Website (Advanced)"

            >
            <Row>
            <Col xs={12}>
            <Select field={{
                        name: 'CaseType',
                        value: this.state.embeddedPublicIntakeFormCaseType,
                        onChange: (value) => {
                            if (!value || typeof(value) !== 'string') {
                                if (value.target && value.target.value) {
                                    value = value.target.value;
                                } else {
                                    return;
                                }
                            }

                            this.setState({ embeddedPublicIntakeFormCaseType: value });
                        }
                    }}
                    label="Select Intake Form"
                    options={this.props.caseTypes}
            />
            </Col>
            </Row>
            <Row>
            <Col xs={12}>
            <TextArea rows={5}
                      label="Copy the IFRAME code to your website HTML code in the position where you want the intake form to appear"
                      forceFullSize
                      field={{
                          name: 'EmbedAreaText',
                          value: `<iframe width="100%" height="100%" scrolling="auto" src="https://app.casetempo.com/intake/${this.props.loggedIn && this.props.loggedIn['CompanyHash']}?q=${this.state.embeddedPublicIntakeFormCaseType}&embedded=true"></iframe>`
                      }}
            />
            </Col>
            </Row>
            </ConfirmDialog>
            </div>);

        return menu;
    }
}

const mapStateToProps = (state, ownProps) => {
    let location;
    let routingInfo = state.routing;
    let impersonating = false;
    if (routingInfo) {
        location = routingInfo.locationBeforeTransitions;
    }

    if (location) {
        if (location.query) {
            impersonating = location.query.impersonating;
        }

        location = location.pathname;
    }

    if (!location) {
        location = '';
    }

    let selectedTab = 'cases';
    if (location.startsWith('/case/all')) {
        selectedTab = 'cases';

    } else if (location.startsWith('/case/reports')) {
        selectedTab = 'reports';

    } else if (location.startsWith('/case')) {
        selectedTab = 'case';

    } else if (location.startsWith('/user')) {
        selectedTab = 'account';

    } else if (location.startsWith('/client/all')) {
        selectedTab = 'clients';

    } else if (location.startsWith('/client')) {
        selectedTab = 'client';
    }

    let states = undefined;
    let currentConfig = state.user.config;
    if (currentConfig) {
        if (currentConfig['caseStates']) {
            states = currentConfig['caseStates'];

        } else {
            states = [];
        }
    }

    const loggedIn = state.user.loggedIn;
    const isOwner = loggedIn.id === state.user.owner.id;
    let caseTypes;
    if (currentConfig && currentConfig.workflow) {
        caseTypes = currentConfig.workflow.map(v => v.type);
    }

    return {
        cases: state.cases,
        clients: state.clients,
        currentConfig,
        caseTypes,
        location,
        selectedTab,
        states,
        loggedIn,
        isOwner,
        impersonating,
    };
}

export default connect(mapStateToProps)(MainMenu);
